/* eslint-disable camelcase */
/* eslint-disable unicorn/consistent-destructuring */

/**
 * @param {import('@knitiv/api-client-javascript').MinimalNode} linker_info
 * @param {import('@knitiv/api-client-javascript').LinkerKNode} linker_kid
 * @param {string} nodeName
 * @param {?import('angular').translate.ITranslateService} $translate
 * @returns {string}
 */
const makeDefault = (linker_info, linker_kid, nodeName, $translate) => {
	const linker = (linker_info && linker_kid !== '0') ? ` :: ${linker_info.name}` : '';
	return `${$translate ? $translate.instant(nodeName) : nodeName}${linker}`;
};

/**
 * @param {import('~/scripts/services/model/query-column').default} column
 * @param {?import('angular').translate.ITranslateService} $translate
 * @returns {string} Column name
 */
export function makeNodeName(column, $translate = null) {
	const { name: nodeName, linker_info, linker_kid } = column;

	// If we have a custom representation, use it
	if (column?.settings?.label) {
		return column.settings.label;
	}
	else if (column?.kdata?.label) {
		return column.kdata.label;
	}
	return makeDefault(linker_info, linker_kid, nodeName, $translate);
}
